<template>
    <div v-show="showHeader" id="mainVanta">
        <header-component/>
        <main-slider v-if="this.$route.name=='Home'"/>
        <div v-else style="padding-bottom: 100px;"></div>
    </div>
</template>
  
  <script>

  import * as THREE from 'three'
  import NET from 'vanta/dist/vanta.net.min'
  import HeaderComponent from '@/components/header/HeaderComponent.vue'
  import MainSlider from '@/components/mainSlider/MainSlider.vue'

  export default {
    name: 'HomeHeader',
    components: {
      HeaderComponent,
      MainSlider
    },
    computed: {
      showHeader(){
        if (this.$route.name == 'Authorization' || this.$route.name == 'ResetPasswordPage')
          return false
        return true
      },
      showSlider(){
        if (this.$route.name == 'Home')
          return true
        return false
      } 
    },
    mounted() {
        this.vantaEffect = NET({
          el: "#mainVanta",
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          scale: 1.00,
          scaleMobile: 1.00,
          color: 0x0F3384,
          backgroundColor: 0x01174d,
          THREE
        });
      },
      methods: {
        createVanta() {
          this.vantaEffect = NET({
              el: "#mainVanta",
              mouseControls: true,
              touchControls: true,
              gyroControls: false,
              minHeight: 200.00,
              minWidth: 200.00,
              scale: 1.00,
              scaleMobile: 1.00,
              color: 0x0F3384,
              backgroundColor: 0x01174d,
              THREE});
        },
        destroyVanta() {
          this.vantaEffect.destroy();
        }
      },
      beforeUnmount() {
        this.vantaEffect.destroy();
      },
      watch: {
        '$route.name'(newName,oldName){
          if (oldName == 'Authorization' && newName == 'Home'){
            this.createVanta()
            return
          }
          if (newName == 'Home'){
            this.destroyVanta()
            this.createVanta()
            return
          }
          if (oldName == 'Home' && newName != 'Authorization'){
            this.destroyVanta()
            this.createVanta()
            return
          } 
        }
      }
  }
  </script>
  
